import { FormProvider, useForm } from "react-hook-form";
import { Link, useSearchParams } from "react-router";
import { ResetPasswordForm, type FormInputs } from "./resetPasswordForm";

export const ResetPasswordView = () => {
  const [searchParams] = useSearchParams();
  const prefilledEmail = searchParams.get("email") ?? "";
  const methods = useForm<FormInputs>({ defaultValues: { email: prefilledEmail } });
  const email = methods.watch("email");

  return (
    <FormProvider {...methods}>
      <ResetPasswordForm />
      <div className="mt-3">
        <p className="text-center text-sm text-ui-paragraph-text">
          Do you remember your password?{" "}
          <Link
            to={email ? `/login?email=${encodeURIComponent(email)}` : "/login"}
            className="font-medium text-primary hover:text-primary/80"
          >
            Login here.
          </Link>
        </p>
      </div>
    </FormProvider>
  );
};
